export const VTMapRouteStyle: google.maps.MapTypeStyle[] = [
    {
        "featureType": "all",
        "elementType": "labels.text", // Valid elementType
        "stylers": [
            {
                "color": "#878787"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke", // Valid elementType
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all", // Valid elementType
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all", // Valid elementType
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke", // Valid elementType
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all", // Valid elementType
        "stylers": [
            {
                "color": "#e9f5fd"
            }
        ]
    }
];
